import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import EditableText from './EditableText';
import { useDashboard } from '../contexts/DashboardContext';

const KPICard = ({ title, value, change, changeType, icon: Icon, prefix = '', suffix = '', field, type = 'number' }) => {
  const { updateField } = useDashboard();
  const isPositive = changeType === 'positive' || change >= 0;

  return (
    <div data-testid={`kpi-card-${field}`} className="bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-all duration-200 p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <p className="kpi-label mb-3">{title}</p>
          <div className="kpi-number">
            <EditableText
              value={value}
              field={field}
              onUpdate={updateField}
              type={type}
              prefix={prefix}
              suffix={suffix}
            />
          </div>
        </div>
        {Icon && (
          <div className={`p-3 rounded-lg ${
            isPositive ? 'bg-emerald-50 text-emerald-600' : 'bg-red-50 text-red-600'
          }`}>
            <Icon className="w-6 h-6" strokeWidth={2} />
          </div>
        )}
      </div>
      {change !== undefined && (
        <div className={`flex items-center metric-change ${
          isPositive ? 'positive-value' : 'negative-value'
        }`}>
          {isPositive ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
          <span>{Math.abs(change)}% from last period</span>
        </div>
      )}
    </div>
  );
};

export default KPICard;